import { Controller } from "@hotwired/stimulus"

// Handles tag selection for reviews
export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    // Controller is ready
  }

  toggleTag(event) {
    // The checkbox will handle the toggle automatically
    // This controller can be extended for additional functionality like
    // limiting selections, showing counts, etc.
  }
}
